import { BarChart, FunnelChart, LineChart, PieChart } from 'echarts/charts';
import {
  DataZoomComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { LabelLayout, UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';

// TODO Придумать как отключить подгрузку для клиентского модуля
const globalEcharts: { lib: any } = { lib: null };

echarts.use([
  // Charts
  LineChart,
  BarChart,
  PieChart,
  FunnelChart,

  // Components
  ToolboxComponent,
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  DataZoomComponent,

  // Features
  LabelLayout,
  UniversalTransition,

  // Renderer
  CanvasRenderer
]);

globalEcharts.lib = echarts;

export default globalEcharts;
